import { getNodeValidationError, isNodeComplete } from 'modules/workflows/lib/workflowValidation'

import { EdgeUI, NodeUI } from './types'
import { nodeIsValid } from './utils'

// Utility function to update nodes with validation
export const updateNodesWithValidation = (nodes: NodeUI[], edges: EdgeUI[]): NodeUI[] => {
  // Update nodes with validation information
  return nodes.map((node) => {
    const updatedNode = { ...node }
    // Node is valid if it has proper connectivity AND is complete (all required fields filled)
    const hasValidConnectivity = nodeIsValid(node, edges)
    const hasCompleteData = isNodeComplete(node)
    const isActuallyValid = hasValidConnectivity && hasCompleteData

    // Suppress validation in two cases:
    // 1. Node is selected (sidepanel is open) - always suppress while editing
    // 2. Node has suppressInitialValidation flag - prevents flash on newly created nodes
    const isSelected = node.selected === true
    const hasInitialSuppression = node.data?.suppressInitialValidation === true

    // Clear the flag when node becomes selected - this ensures that once the user
    // has interacted with a node (sidepanel opened), the flag is cleared and won't
    // suppress validation when they later deselect the node
    const shouldClearFlag = isSelected && hasInitialSuppression

    const shouldSuppressValidation = isSelected || hasInitialSuppression

    const isValid = shouldSuppressValidation ? true : isActuallyValid

    // Get validation error message for tooltip (only if not suppressing validation)
    const validationError =
      shouldSuppressValidation || isActuallyValid
        ? undefined
        : (getNodeValidationError(node) ?? undefined)

    updatedNode.data = {
      ...node.data,
      isValid,
      validationError,
      ...(shouldClearFlag ? { suppressInitialValidation: false } : {}),
    }
    return updatedNode
  })
}
